import React from 'react';
import classNames from 'classnames';

import type { LogoSize } from '.';

import styles from './companyLogo.module.css';

interface GenericCompanyLogoProps {
  companyName: string;
  className?: string;
  size?: LogoSize;
  imgWidth?: number;
  imgHeight?: number;
}

const colors = [
  '#AD1457', // H, T, 0
  '#D32F2F', // I, U, 1
  '#0288D1', // J, V, 2
  '#FBBE07', // K, W, 3
  '#CCDB39', // L, X, 4
  '#303F9F', // A, M, Y, 5
  '#FFA000', // B, N, Z, 6
  '#F44336', // C, O, 7
  '#673AB7', // D, P, 8
  '#7B1FA2', // E, Q, 9
  '#4CAF50', // F, R,
  '#388E3C', // G, S
];

const GenericCompanyLogo = (props: GenericCompanyLogoProps) => {
  const { className = '', size = '', companyName, imgWidth, imgHeight } = props;

  const companyInitial = (companyName || '').toUpperCase().replace('THE ', '').charAt(0);
  const color = colors[companyInitial.charCodeAt(0) % colors.length];

  if (!companyInitial) {
    return (
      <img
        alt={`${companyInitial}`}
        src="../../ui-router/images/medium-company-icon.svg"
        className={classNames(styles['generic-company-logo'], styles[size], className)}
        width={imgWidth}
        height={imgHeight}
      />
    );
  }

  return (
    <div
      className={classNames(
        styles['generic-company-logo'],
        'd-flex',
        'align-items-center',
        'justify-content-center',
        styles[size],
        className
      )}
      style={{ backgroundColor: color }}
    >
      {companyInitial}
    </div>
  );
};

export default GenericCompanyLogo;
